import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default Component => {
  return props => {
    const location = useLocation();
    const ref = useRef();

    const { title } = props;
    let selected = false;
    if (location.hash) {
      const section = location.hash.slice(1);
      if (title.replace(' ', '-').toLowerCase() === section) {
        selected = true;
      }
    }

    useEffect(() => {
      if (selected && location.hash) {
        const yOffset = -200;
        const element = ref.current;
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        window.history.pushState({}, '', location.pathname);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);

    return <Component mainRef={ref} {...props} selected={selected} />;
  };
};
